import { NGXLogger } from 'ngx-logger';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DEFINITIONS } from '../shared/app-definitions';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

interface AuthResponse {
  user?: string;
}


@Injectable({ providedIn: 'root' })

export class AuthenticationService {
  private logger = inject(NGXLogger);
  private http = inject(HttpClient);

  constructor() {
    this.logger.info('(authentication.service) => constructor()');
  }

  public get isAuthenticated(): Observable<boolean> {
    const headerDict = {'Cache-Control': 'no-cache'};
    const requestOptions = { headers: new HttpHeaders(headerDict)};
   
    return this.http
     .get<AuthResponse>(DEFINITIONS.serverUrlUsersAuthenticate, requestOptions)
     .pipe(
      map((resp: AuthResponse) => {
        //http response ok
        if (resp.user) {
          sessionStorage.setItem(DEFINITIONS.sessParEcadUser, resp.user);
        }
        sessionStorage.setItem(DEFINITIONS.sessParEcadUserLoggedIn, 'true');
        return true;
      }),
      catchError((err: unknown) => {
        //http error response
        this.logger.info('(authentication.service)[EXCEPTION] isAuthenticated(), error' + JSON.stringify(err));  //.info!!!
        return of(false);
      })
    );
  }

}

